// extracted by mini-css-extract-plugin
module.exports = {"promotionworldGroupGroupedTitle":"_3NNSVxEEyflfJuKpdNkBL1","promotionworldGroupGroupedItem":"_2GVnEFUWwRGfoNqsqZLccP","promotionworldGroupGroupedMore":"_1OmRu7WuYAp8R4fg3GfKSa"};